<template>
  <!-- 勤務表一覧 -->
  <div id="List">
    <CCard>
      <CCardHeader><h2>勤務表一覧</h2></CCardHeader>
      <CCardBody>
        <table class="table search-table">
          <tr>
            <th style="width: 100px">年月</th>
            <th style="width: 75px"></th>
            <th style="width: 50px"></th>
            <th colspan="2"></th>
          </tr>
          <tr>
            <td>
              <select
                class="custom-select"
                v-model="year"
                style="width: 90px"
              >
                <option
                  v-for="option in yearOption"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>
              <select
                class="custom-select"
                v-model="month"
                style="width: 70px"
              >
                <option
                  v-for="option in monthOption"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>業務分</td>
            <td>
              <button class="btn btn-primary" @click="callList">検索</button>
            </td>
          </tr>
        </table>
      </CCardBody>
      <template v-if="callFlg">
        <CCardBody>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col" width="100px">社員名</th>
                  <th scope="col" width="80px">ステータス</th>
                  <th scope="col" width="100px">承認者</th>
                  <th scope="col" width="100px">承認日</th>
                  <th scope="col" width="120px">超過控除</th>
                  <th scope="col">差戻し理由</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.name">
                  <td>
                    <router-link
                      :to="{
                        name: rosterInfo,
                        params: {
                          user_id: item.user_id,
                          year: year,
                          month: month,
                          user_name: item.user_name,
                        },
                      }"
                      >{{ item.user_name }}</router-link
                    >
                  </td>
                  <td :style="statusColor(item.status)" nowrap>{{ item.status }}</td>
                  <td>{{ item.approver }}</td>
                  <td>{{ item.approval_date }}</td>
                  <td>
                    <span :style="{ color: getWorkTimeStatus(item).color, 'font-weight':'bold'}">
                      {{ getWorkTimeStatus(item).text }}
                    </span>
                  </td>
                  <td class="linefeed">{{ item.comment }}</td>
                  <td white-space: nowrap>
                    <button class="btn btn-info" @click="openPDF(item.user_id)">
                      PDF
                    </button>
                    <button class="btn btn-danger" 
                    :loading="loading"
                    @click="revocationOfApproval(item.user_id, item.user_name,item.document_type,item.approver_user_id,item.comment,item.submissionId)"
                    v-show="item.status === '承認済み'">承認取消</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-center">
            <!-- ページング処理 -->
            <VPagination
              v-model="currentPage"
              :click-handler="changePage"
              :page-count="totalPages"
              :force-ellipses="true"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :prev-text="'<'"
              :next-text="'>'"
              :prev-link-class="'page-link'"
              :next-link-class="'page-link'"
              :page-link-class="'page-link'"
              :class-prefix="'pagination'"
            />
          </div>
        </CCardBody>
      </template>
    </CCard>
  </div>
</template>
  
  <script>
import ConstList from "../../ConstList";
import axios from "axios";
import moment from "moment";
import VPagination from "vuejs-paginate";
export default {
  components: {
    VPagination,
  },
  data() {
    return {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      date: "",
      items: [],
      callFlg: false,
      rosterInfo: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      loading: false,
    };
  },
  created() {
    this.yearOption = ConstList.YEAR_OPTION;
    this.monthOption = ConstList.MONTH_OPTION;
    this.rosterInfo = ConstList.ROUTE_ROSTER_INFO;
  },

  methods: {
    callList: function () {
      this.callFlg = false;
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      this.fetchTotalPages();
      params.append("currentPage", this.currentPage);
      params.append("pageSize", this.pageSize);
      params.append("totalPages", this.totalPages);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/roster/List", {
          params: {
            year: this.year,
            month: this.month,
            currentPage: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then((response) => {
          this.items = response.data;
          this.callFlg = true;
          // sessionStorageへ保存
          sessionStorage.setItem(
            "rosterList-search-items",
            JSON.stringify(this.items)
          );
          sessionStorage.setItem(
            "rosterList-search-params",
            JSON.stringify({
              year: this.year,
              month: this.month,
              currentPage: this.currentPage,
              pageSize: this.pageSize,
              totalPages: this.totalPages,
            })
          );
        })
        .catch((error) => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        });
    },
    // 承認状態の識別
    statusColor(status) {
      switch (status) {
        case ConstList.REJECT:
        case ConstList.UNSUBMITTED: 
          return { color: 'red' };
        case ConstList.APPROVAL_PENDING:
          return { color: 'orange' };
        case ConstList.APPROVAL:
          return { color: 'green' };
        default:
          return {};
      }
    },
    // ページ変更
    changePage: function (page) {
      this.currentPage = page;
      this.callList();
    },
    // アイテム数とページサイズに基づいて合計ページ数を計算
    fetchTotalPages: function () {
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/roster/count", {
          params: {
            year: this.year,
            month: this.month,
          },
        })
        .then((response) => {
          const totalCount = response.data;
          this.totalPages = Math.ceil(totalCount / this.pageSize);
        })
        .catch((error) => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        });
    },
   // 承認取消メソッド
   revocationOfApproval: function (user_id, user_name,document_type,approver_user_id,comment,id) {
      if (
        confirm(
          user_name +
            "さんの" +
            this.year +
            "年" +
            this.month +
            "月" +
            "の承認を取り消してもよろしいですか？"
        )
      ) {
        this.loading = true;
        this.sendList = [];
        const selectItem = {
        user_id: user_id,
        year: this.year,
        month: this.month,
        id: id,
        approver_user_id:
        approver_user_id === null ? user_id : approver_user_id,
        comment: comment,
        document_type: document_type,
        sns_message: this.sns_message,
        };
        this.sendList.push(selectItem);
        // 非同期処理
        axios
        .post(
          process.env.VUE_APP_API_ORIGIN + "/submission/revocation_of_approval",
          this.sendList
        )
        .then(() => {
          alert("承認を取り消しました");
          this.callList();
        })
        .catch((error) => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        })
        .finally(() => {
          this.loading = false;
        });
      }
    },
    // PDF出力メソッド
    openPDF: function (user_id) {
      const params = new URLSearchParams();
      params.append("user_id", user_id);
      params.append("year", this.year);
      params.append("month", this.month);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/roster/pdf", {
          params: params,
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, "_blank");
        })
        .catch((error) => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        });
    },
    // yyyy/mm/ddフォーマット変換
    formatDate(dateStr) {
      if (!dateStr) return '';
      const [yyyy, mm, dd] = dateStr.split('-');
      return `${yyyy}/${mm}/${dd}`;
    },
    // 分数を H:MM 文字列に変換
    toHMString(value) {
      const num = Number(value);
      if (!Number.isFinite(num)) return value; // "12:30" のような場合はそのまま返す
      const h = Math.floor(num / 60);
      const m = num % 60;
      return `${h}:${m.toString().padStart(2, "0")}`;
    },
    // H:MM や "150" → 分に変換
    hmToMinutes(v) {
      if (v === null || v === undefined) return NaN;
      const s = String(v).trim();
      if (s === '') return NaN;

      if (s.includes(':')) {
        const [h, m = '0'] = s.split(':');
        const hh = Number(h);
        const mm = Number(m);
        if (!Number.isFinite(hh) || !Number.isFinite(mm)) return NaN;
        return hh * 60 + mm;
      }
      const hh = Number(s);
      if (!Number.isFinite(hh)) return NaN;
      return hh * 60; // 数字だけなら時間と解釈
    },

    // 分 → H:MM
    formatDiff(mins) {
      const abs = Math.abs(mins);
      const h = Math.floor(abs / 60);
      const m = abs % 60;
      return `${h}:${m.toString().padStart(2, '0')}`;
    },

    // 判定ロジック
    getWorkTimeStatus(item) {
      const totalSrc = item.totalTime;
      const totalHM  = this.toHMString(totalSrc);
      const totalMin = this.hmToMinutes(totalHM);

      // 下限/上限は snake で来る（この画面は user_name など snake を使用）
      const minSrc = item.base_time_min ?? item.baseTimeMin;
      const maxSrc = item.base_time_max ?? item.baseTimeMax;
      const minMin = this.hmToMinutes(minSrc);
      const maxMin = this.hmToMinutes(maxSrc);
      const hasTotal = Number.isFinite(totalMin);
      const hasMin   = Number.isFinite(minMin);
      const hasMax   = Number.isFinite(maxMin);
      const BAND5H   = 5 * 60;

      if (!hasTotal) return { text: '基準時間内', color: 'green' };
      if (!hasMin && !hasMax) return { text: '基準時間内', color: 'green' };

      if (hasMax && totalMin > maxMin) {
        return { text: `【超過】${this.formatDiff(totalMin - maxMin)}`, color: 'red' };
      }
      if (hasMin && totalMin < minMin) {
        return { text: `【控除】${this.formatDiff(minMin - totalMin)}`, color: 'blue' };
      }

      // 上限 - 5H 以内 → オレンジ
      if (hasMax && totalMin >= (maxMin - BAND5H) && totalMin <= maxMin) {
        return { text: '基準時間内', color: 'orange' };
      }
      // 下限 + 5H 以内 → 水色
      if (hasMin && totalMin >= minMin && totalMin <= (minMin + BAND5H)) {
        return { text: '基準時間内', color: '#00BFFF' }; // water-light（お好みで 'deepskyblue' でも可
      }
      return { text: '基準時間内', color: 'green' };
    },
  },
  mounted: function () {
    // 前回の検索パラメータがあれば取得
    if (
      Object.prototype.hasOwnProperty.call(
        sessionStorage,
        "rosterList-search-items"
      )
    ) {
      //this.callFlg = true;
      //this.items = JSON.parse(
      //  sessionStorage.getItem("rosterList-search-items")
      //);
      const params = JSON.parse(
        sessionStorage.getItem("rosterList-search-params")
      );
      this.year = params.year;
      this.month = params.month;
      this.callList();
      this.callFlg = true;
      //this.currentPage = params.currentPage;
      //this.pageSize = params.pageSize;
      //this.totalPages = params.totalPages;
    } else {
      const today = moment().subtract(1, 'months');
      this.year = today.format("YYYY");
      this.month = today.format("M");
    }
  },
};
</script>

<style scoped>
th,
td {
  white-space: nowrap;
}
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

td {
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
